import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaiairporttogoacab() {



    const cardData = {

keyword: "Mumbai Airport to Goa Cab",

headingDescription:
    "Mumbai Airport Cab offers reliable and affordable Mumbai Airport to Goa Cab services for long-distance travel, family vacations, group tours, honeymoon trips, corporate travel, and one-way or round-trip journeys. We provide a wide range of well-maintained vehicles including Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus with professional and experienced chauffeurs. With 24x7 availability, transparent pricing, flight tracking support, doorstep pickup from Mumbai Airport, and safe highway driving via the Mumbai–Goa route, we ensure a smooth, comfortable, and hassle-free journey to Goa.",

topPlaces: [
    {
        title: "Baga Beach",
        description:
            "Baga Beach is one of the most popular beaches in Goa, known for water sports, beach shacks, nightlife, and vibrant tourist activity throughout the year."
    },
    {
        title: "Calangute Beach",
        description:
            "Calangute Beach is often called the Queen of Beaches in Goa and is famous for its long coastline, shopping stalls, water sports, and lively tourist crowd."
    },
    {
        title: "Anjuna Beach",
        description:
            "Anjuna Beach is known for its rocky shoreline, flea market, sunset views, and relaxed hippie vibe, making it a favorite among international and domestic travelers."
    },
    {
        title: "Fort Aguada",
        description:
            "Fort Aguada is a well-preserved Portuguese fort overlooking the Arabian Sea, famous for its lighthouse, sea views, and historical significance."
    },
    {
        title: "Dudhsagar Waterfalls",
        description:
            "Dudhsagar Waterfalls is one of India’s tallest waterfalls located on the Goa–Karnataka border, surrounded by dense forests and breathtaking natural beauty."
    },
    {
        title: "Basilica of Bom Jesus",
        description:
            "Basilica of Bom Jesus is a UNESCO World Heritage Site in Old Goa, known for its baroque architecture and sacred religious importance."
    },
    {
        title: "Palolem Beach",
        description:
            "Palolem Beach in South Goa is famous for its calm waters, beach huts, scenic beauty, and peaceful atmosphere ideal for relaxation."
    },
    {
        title: "Chapora Fort",
        description:
            "Chapora Fort is a popular viewpoint offering stunning sunset views over Vagator Beach and is well known from Bollywood movies."
    },
    {
        title: "Candolim Beach",
        description:
            "Candolim Beach is a peaceful beach in North Goa known for clean shores, water sports, and a relaxing environment away from heavy crowds."
    },
    {
        title: "Se Cathedral",
        description:
            "Se Cathedral is one of the largest churches in Asia, admired for its Portuguese-Gothic architecture and historical importance in Old Goa."
    }
],



services: [
{
name: "Mumbai Airport to Goa One Way Cab",
description: "Mumbai Airport to Goa One Way Cab service by 1Touch Cabs provides safe, reliable, and comfortable long-distance travel for passengers arriving at Mumbai Airport and heading directly to Goa. Our service includes a wide range of well-maintained vehicles such as Sedan, Swift Dzire, Ertiga, Kia Carens, Innova, Innova Crysta, SUV, Luxury Cars, and Tempo Traveller options. With experienced chauffeurs trained for long highway routes, we ensure smooth travel via the Mumbai–Goa corridor with timely pickup from the airport, luggage assistance, and stress-free journey. We offer 24x7 availability, transparent pricing, instant booking, and flexible pickup scheduling for a seamless travel experience.",
},
{
name: "Mumbai Airport to Goa Cab Service",
description: "Mumbai Airport to Goa Cab Service offers dependable intercity transportation for tourists, families, business travelers, and international passengers. 1Touch Cabs ensures clean vehicles, professional drivers, and comfortable long-distance rides with door-to-door airport pickup and Goa drop service.",
},
{
name: "Mumbai Airport to Goa Taxi",
description: "Mumbai Airport to Goa Taxi service provides safe and convenient transportation with experienced chauffeurs and well-maintained air-conditioned vehicles. 1Touch Cabs focuses on punctual airport pickup, smooth highway travel, and customer satisfaction for all types of travelers.",
},
{
name: "Mumbai Airport to Goa Taxi Service",
description: "Mumbai Airport to Goa Taxi Service ensures reliable and comfortable travel with professional drivers and a variety of vehicle options. 1Touch Cabs guarantees safe journeys, timely pickups, and smooth rides for all passengers heading to Goa.",
},
{
name: "Mumbai Airport to Goa Outstation Cab",
description: "Mumbai Airport to Goa Outstation Cab service is designed for long-distance travelers seeking safe, comfortable, and affordable transport. 1Touch Cabs provides experienced chauffeurs, clean vehicles, and flexible travel options for outstation journeys.",
},
{
name: "Mumbai Airport to Goa Car Rental",
description: "Mumbai Airport to Goa Car Rental service offers flexible travel solutions for individuals, families, and groups. 1Touch Cabs provides well-maintained vehicles with professional drivers for a comfortable and personalized Goa journey.",
},
{
name: "Mumbai Airport to Goa Drop Taxi",
description: "Mumbai Airport to Goa Drop Taxi service ensures direct point-to-point transportation from Mumbai Airport to Goa without return charges. 1Touch Cabs offers affordable pricing, safe driving, and hassle-free travel experience.",
},
{
name: "Mumbai Airport to Goa Private Cab",
description: "Mumbai Airport to Goa Private Cab service offers exclusive travel with dedicated vehicles and personalized scheduling. 1Touch Cabs ensures privacy, comfort, and flexible travel arrangements for passengers heading to Goa.",
},
{
name: "Mumbai Airport to Goa AC Cab Service",
description: "Mumbai Airport to Goa AC Cab Service provides fully air-conditioned, comfortable, and clean vehicles for long-distance travel. 1Touch Cabs ensures a pleasant journey with professional chauffeurs and smooth highway driving.",
},
{
name: "Navi Mumbai Airport to Goa Cabs",
description: "Navi Mumbai Airport to Goa Cabs service offers reliable airport pickup and direct transportation to Goa for travelers arriving at NMIA. 1Touch Cabs provides professional drivers, comfortable vehicles, and 24x7 availability.",
},
{
name: "Navi Mumbai Airport to Goa Cab Service",
description: "Navi Mumbai Airport to Goa Cab Service ensures safe, timely, and comfortable long-distance travel from NMIA to Goa. 1Touch Cabs offers multiple vehicle options and experienced chauffeurs for smooth journeys.",
},
{
name: "Navi Mumbai Airport to Goa Taxi",
description: "Navi Mumbai Airport to Goa Taxi service provides convenient and affordable transportation with clean vehicles and professional drivers. 1Touch Cabs ensures hassle-free travel for families, tourists, and corporate travelers.",
},
{
name: "Navi Mumbai Airport to Goa Taxi Service",
description: "Navi Mumbai Airport to Goa Taxi Service offers reliable airport pickup and long-distance travel with punctual drivers and comfortable vehicles. 1Touch Cabs guarantees smooth and safe journeys to Goa.",
},
{
name: "Navi Mumbai Airport to Goa One Way Cab",
description: "Navi Mumbai Airport to Goa One Way Cab service provides budget-friendly transportation without return fare charges. 1Touch Cabs ensures affordable pricing and comfortable travel for solo and group passengers.",
},
{
name: "Navi Mumbai Airport to Goa Outstation Cab",
description: "Navi Mumbai Airport to Goa Outstation Cab service offers safe and reliable long-distance travel with professional chauffeurs and well-maintained vehicles. 1Touch Cabs ensures smooth highway journeys.",
},
{
name: "Navi Mumbai Airport to Goa Car Rental",
description: "Navi Mumbai Airport to Goa Car Rental service provides flexible travel options for families and groups with private vehicles and experienced drivers. 1Touch Cabs ensures comfort and convenience.",
},
{
name: "Navi Mumbai Airport to Goa Drop Taxi",
description: "Navi Mumbai Airport to Goa Drop Taxi service ensures direct, hassle-free transportation from NMIA to Goa with transparent pricing and safe driving.",
},
{
name: "Navi Mumbai Airport to Goa Private Taxi",
description: "Navi Mumbai Airport to Goa Private Taxi service offers exclusive and comfortable travel with dedicated vehicles and personalized pickup schedules.",
},
{
name: "Navi Mumbai Airport to Goa AC Cab Service",
description: "Navi Mumbai Airport to Goa AC Cab Service provides fully air-conditioned, comfortable long-distance travel with professional chauffeurs and clean vehicles."
}
],

tableData: [
["Mumbai Airport to Goa One Way Cab","Mumbai Airport to Goa Cab Service"],
["Mumbai Airport to Goa Taxi","Mumbai Airport to Goa Taxi Service"],
["Mumbai Airport to Goa Outstation Cab","Mumbai Airport to Goa Car Rental"],
["Mumbai Airport to Goa Drop Taxi","Mumbai Airport to Goa Private Cab"],
["Mumbai Airport to Goa AC Cab Service","Navi Mumbai Airport to Goa Cabs"],
["Navi Mumbai Airport to Goa Cab Service","Navi Mumbai Airport to Goa Taxi"],
["Navi Mumbai Airport to Goa Taxi Service","Navi Mumbai Airport to Goa One Way Cab"],
["Navi Mumbai Airport to Goa Outstation Cab","Navi Mumbai Airport to Goa Car Rental"],
["Navi Mumbai Airport to Goa Drop Taxi","Navi Mumbai Airport to Goa Private Taxi"],
["Navi Mumbai Airport to Goa AC Cab Service","Mumbai Airport to Goa One Way Cab"]
],















whychoose: [
    {
        WhyChooseheading: "Reliable Mumbai Airport to Goa Cab Service",
        WhyChoosedescription: "Mumbai Airport Cabs provides dependable Mumbai Airport to Goa Cab services for tourists, families, couples, corporate travelers, and holidaymakers seeking comfortable long-distance transportation."
    },
    {
        WhyChooseheading: "Direct Airport to Goa Transfer Facility",
        WhyChoosedescription: "Passengers arriving at Mumbai Airport can enjoy hassle-free direct transportation to Goa without changing flights, trains, buses, or multiple travel options."
    },
    {
        WhyChooseheading: "Perfect for Beach Holidays and Vacations",
        WhyChoosedescription: "Goa is one of India's most popular tourist destinations, famous for beautiful beaches, nightlife, churches, forts, water sports, seafood, and luxury resorts."
    },
    {
        WhyChooseheading: "Wide Range of Vehicle Options",
        WhyChoosedescription: "Customers can choose Sedan cars, Ertiga, Innova, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, Mini Buses, and premium vehicles according to passenger count and luggage requirements."
    },
    {
        WhyChooseheading: "One-Way and Round Trip Booking Available",
        WhyChoosedescription: "Whether you require a one-way airport transfer, round trip, family vacation package, or customized Goa tour, we provide flexible booking options."
    },
    {
        WhyChooseheading: "Flight Tracking and Timely Airport Pickup",
        WhyChoosedescription: "Our team monitors flight schedules and arrival timings to ensure smooth pickups, even if your flight is delayed or rescheduled."
    },
    {
        WhyChooseheading: "Experienced Drivers for Goa Highway Routes",
        WhyChoosedescription: "Our professional chauffeurs are experienced on Mumbai-Goa routes and ensure safe, comfortable, and stress-free transportation throughout the journey."
    },
    {
        WhyChooseheading: "Ideal for Families, Couples, and Tourist Groups",
        WhyChoosedescription: "From honeymoon couples and family vacationers to corporate groups and friends' trips, we provide suitable vehicles for every Goa travel requirement."
    }
]
};

const faqData = [
    {
        question: "Why do travelers book Mumbai Airport to Goa Cabs?",
        answer: "Many travelers prefer direct cab transportation from Mumbai Airport to Goa for convenience, comfort, privacy, and a flexible travel schedule."
    },
    {
        question: "Can I book a one-way cab from Mumbai Airport to Goa?",
        answer: "Yes, one-way cab services are available along with round-trip and customized Goa holiday packages."
    },
    {
        question: "Which vehicle is suitable for Mumbai Airport to Goa travel?",
        answer: "Sedan cars, Ertiga, Innova, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, and Mini Buses are available according to passenger count and luggage requirements."
    },
    {
        question: "Do you provide airport pickup from all Mumbai Airport terminals?",
        answer: "Yes, pickup services are available from domestic and international terminals of Mumbai Airport."
    },
    {
        question: "Can families book cabs directly from the airport to Goa resorts?",
        answer: "Yes, customers can book direct transfers from Mumbai Airport to hotels, resorts, villas, beaches, and tourist destinations across Goa."
    },
    {
        question: "Are Tempo Travellers available for group Goa trips?",
        answer: "Yes, Tempo Travellers and Mini Buses are available for family groups, corporate outings, bachelor parties, and tourist groups."
    },
    {
        question: "Will the driver wait if my flight is delayed?",
        answer: "Yes, flight schedules are monitored and pickup timings are adjusted according to actual flight arrival times."
    },
    {
        question: "Can sightseeing places be included during the Goa trip?",
        answer: "Yes, customers can customize their itinerary and visit North Goa, South Goa, beaches, forts, churches, waterfalls, casinos, and other attractions."
    },
    {
        question: "Is advance booking recommended for Mumbai Airport to Goa travel?",
        answer: "Yes, advance booking is highly recommended, especially during weekends, holidays, Christmas, New Year, and peak tourist seasons."
    },
    {
        question: "How can I book a Mumbai Airport to Goa Cab?",
        answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Harsh Vora",
        feedback:
            "After landing at Mumbai Airport, our cab to Goa was ready exactly on time. The vehicle was comfortable, the driver was professional, and the entire journey was smooth and enjoyable.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Sonali Patkar",
        feedback:
            "We booked a direct airport-to-Goa transfer for our family vacation. The cab was spacious, clean, and the travel experience was excellent from start to finish.",
        rating: 5
    }
];


















   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];














const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai Airport to Goa Cab Service",
  "image": "https://www.mumbaiairportcabs.com/assets/images/mumbai-airport-to-goa-cab.jpg",
  "description": "Book Mumbai Airport to Goa cab service for safe, comfortable, and reliable outstation travel. Mumbai Airport Cabs offers affordable one-way and round-trip taxi service with professional drivers, clean AC vehicles, and 24x7 availability.",
  "brand": {
    "@type": "Brand",
    "name": "Mumbai Airport Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8800"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹11,999",
    "availability": "https://schema.org/InStock",
    "url": "https://www.mumbaiairportcabs.com/mumbai-airport-to-goa-cab"
  }
};



    return (
        <div>


<Helmet>
  <title>Mumbai Airport to Goa Cab Service | One Way Taxi Booking | +91 9545731161</title>

  <meta
    name="description"
    content="Book Mumbai Airport to Goa cab service for safe and comfortable travel. Affordable one-way and round-trip taxi with professional drivers."
  />

  <meta
    name="keywords"
    content="Mumbai Airport to Goa Cab, Mumbai to Goa one way cab, Mumbai Airport to Goa Cab Service, Mumbai Airport to Goa Taxi, Mumbai Airport Goa cab booking"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>







            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/8.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaiairporttogoacab;